module.exports = __webpack_public_path__ + "img/function-graphs-inactive.e59a940f.png";